import { RuntimeConfig } from 'nuxt/schema'
import { Pinia, PiniaPluginContext } from 'pinia'
import useUserStore from '~/demo_stores/user'
import useFilterStore from '~/demo_stores/filter'
import useSubjectStore from '~/demo_stores/subject'

export default defineNuxtPlugin(nuxtApp => {
    const config: RuntimeConfig = useRuntimeConfig()

    if (config.public.APP_ENV === 'demo') {
      const pinia = nuxtApp.$pinia as Pinia

      pinia.use(function ({ store }: PiniaPluginContext) {
        Object.assign(store, useUserStore(nuxtApp))
        Object.assign(store, useFilterStore())
        Object.assign(store, useSubjectStore())
      })
    }
})
